/**
 * @generated SignedSource<<e5a803d2cbed0595790878d7c3e81da1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type layoutViewRendererFragment$data = {
  readonly __typename: "HelpLayout";
  readonly id: string;
  readonly sections: {
    readonly __typename: "HelpLayoutSectionConnection";
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __id: string;
        readonly " $fragmentSpreads": FragmentRefs<"layoutHeaderFragment" | "sectionViewRendererFragment">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "layoutViewRendererFragment";
};
export type layoutViewRendererFragment$key = {
  readonly " $data"?: layoutViewRendererFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"layoutViewRendererFragment">;
};

import layoutRendererRefetchQuery_graphql from './layoutRendererRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "sections"
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "kind": "RootArgument",
      "name": "helpCenterAri"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": layoutRendererRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "layoutViewRendererFragment",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "sections",
      "concreteType": "HelpLayoutSectionConnection",
      "kind": "LinkedField",
      "name": "__layoutRendererFragment_sections_connection",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "concreteType": "HelpLayoutSectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "HelpLayoutSection",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "sectionViewRendererFragment"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "layoutHeaderFragment"
                },
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__id"
                    }
                  ]
                },
                (v1/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "cursor"
            }
          ]
        },
        {
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "endCursor"
            },
            {
              "kind": "ScalarField",
              "name": "hasNextPage"
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "HelpLayout"
};
})();

(node as any).hash = "f0e36a298e34cd645390386fd7cd202a";

export default node;
